const columns = [
  {
    "title": "개인행복도",
    "category": null,
    "description": "",
    "avgValue": 41,
  },
  {
    "title": "직장만족도",
    "category": null,
    "description": "",
    "avgValue": 41,
  },
  {
    "title": "직장충성도",
    "category": null,
    "description": "",
    "avgValue": 35,
  },
  {
    "title": "업무자율성",
    "category": "직무",
    "description": "나는 내가 일하는 방식을 자율적으로 조절할 수 있다.",
    "avgValue": null,
  },
  {
    "title": "업무의미감",
    "category": "직무",
    "description": "나는 나의 일을 통해 성장하고 있다.",
    "avgValue": null,
  },
  {
    "title": "업무자신감",
    "category": "직무",
    "description": "나는 도전적인 업무도 성공적으로 해낼 자신이 있다.",
    "avgValue": null,
  },
  {
    "title": "상사지원",
    "category": "관계",
    "description": "나의 상사는 내가 업무를 완수하는 데 필요한 지원을 제공해준다.",
    "avgValue": null,
  },
  {
    "title": "동료지원",
    "category": "관계",
    "description": "나는 회사 생활을 할 때 동료에게 필요한 도움을 받을 수 있다.",
    "avgValue": null,
  },
  {
    "title": "표현의자유",
    "category": "관계",
    "description": "나는 나의 의견을 회사 사람들에게 자유롭게 표현할 수 있다.",
    "avgValue": null,
  },
  {
    "title": "워라밸",
    "category": "문화",
    "description": "나는 나의 일과 삶을 조화롭게 양립할 수 있다.",
    "avgValue": null,
  },
  {
    "title": "스트레스",
    "category": "문화",
    "description": "나는 지난 1년 내 번아웃 증후군을 경험한 적 있다.",
    "avgValue": null,
  },
  {
    "title": "복지",
    "category": "문화",
    "description": "나는 우리 회사의 복지 제도에 충분히 만족한다.",
    "avgValue": null,
  },
  {
    "title": "신뢰",
    "category": "문화",
    "description": "회사에 부정행위가 생길 경우, 우리 회사는 합당한 조치를 취할 것이다.",
    "avgValue": null,
  }
];

export const chartColumnsExcludedIndexes = [0, 1, 2];

export const getTextChartColumns = () => {
  return columns.filter((column, index) => chartColumnsExcludedIndexes.indexOf(index) !== -1);
};

export const getRadarChartColumns = () => {
  return columns.filter((column, index) => chartColumnsExcludedIndexes.indexOf(index) === -1);
};

export const getColumnNameByIndex = index => {
  const column = columns[index];
  return column && `${column.category && `[${column.category}] `}${column.title}`;
};

export const getDescriptionByTitle = title => {
  const column = columns.find(column => column.title === title);
  return column && column.description;
};

export default columns;
